import { AuthProvider } from 'react-admin';
import { OpenAPI, UserService } from '../api';
import { getUserData } from './jwt';

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    const { token } = await UserService.loginUser(username, password);
    localStorage.setItem('token', token ?? '');
    const user = getUserData(token ?? '');
    if (user && user.id === 1) {
      localStorage.setItem('permissions', 'admin');
    } else {
      localStorage.setItem('permissions', 'user');
    }
    OpenAPI.TOKEN = token;
  },
  logout: async () => {
    try {
      await UserService.logoutUser();
      localStorage.removeItem('token');
      localStorage.removeItem('permissions');
      OpenAPI.TOKEN = undefined;
    } catch (e) {
      console.log(e);
    }
  },
  checkError: ({ status }: { status: number }) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      OpenAPI.TOKEN = undefined;
      return Promise.reject();
    }
    return Promise.resolve();
  },
  checkAuth: () => {
    const token = localStorage.getItem('token');
    if (!token) {
      return Promise.reject();
    }
    OpenAPI.TOKEN = token;
    return UserService.checkUserToken();
  },
  getIdentity: async () => {
    const token = localStorage.getItem('token')!;
    const user = getUserData(token);
    const data = await UserService.getUserByName(user?.id ?? -1);
    return {
      id: data.id ?? -1,
      fullName: `${data.lastName} ${data.firstName}`,
      avatar: '',
    };
  },
  getPermissions: () => {
    const role = localStorage.getItem('permissions');
    console.log(role);
    return role ? Promise.resolve(role) : Promise.reject();
  },
};
